// extracted by mini-css-extract-plugin
export var wrapperDesayunos = "Desayunos-module--wrapperDesayunos--17vq0";
export var wrapperTitle = "Desayunos-module--wrapperTitle--g0jfy";
export var desayunos = "Desayunos-module--desayunos--F4Eh4";
export var desayuno = "Desayunos-module--desayuno--2FtA-";
export var wrapperImg = "Desayunos-module--wrapperImg--3qjlP";
export var img = "Desayunos-module--img--2uPm2";
export var wrapperInfo = "Desayunos-module--wrapperInfo--1Ljk1";
export var text = "Desayunos-module--text--3i25G";
export var name = "Desayunos-module--name--xqSYZ";
export var desc = "Desayunos-module--desc--2gb5I";
export var precio = "Desayunos-module--precio--R8puL";
export var avalible = "Desayunos-module--avalible--ldcv7";
export var disable = "Desayunos-module--disable--1N1od";
export var recordatorio = "Desayunos-module--recordatorio--3lZoc";
export var wrapperContact = "Desayunos-module--wrapperContact--3WKk9";